import util from "../../../util";

export { Analytics } from "../../js/Analytics";
export class ShowcaseAnalytics {
    static makeMosaicEventProperties(item) {
        let tier = "";

        switch (Number(item.featured_type || item.featured_type_varchar)) {
            case 16302:
            case 16303:
                tier = "Regular ";
                break;
            case 16304:
            case 16305:
                tier = "Premium ";
                break;
            default:
                tier = "";
                break;
        }

        return {
            action: "Showcase " + tier + "Mosaic_" + item.name,
            label: `${window.location.origin}/item/${util.convertToUrlKey(item.name)}/${item.sku}`,
            value: item.sku, // TODO(trevor) Need to figure out what value we want here, banners use io_number
            seller: {
                id: item.seller_id,
                name: item.seller_name
            }
        };
    }

    static makeInformationEventProperties(action_prefix, item, link) {
        return {
            action: action_prefix + item.name,
            label: link,
            value: item.sku,
            seller: {
                id: item.seller_id,
                name: item.seller_name
            }
        };
    }
}